import React from "react";

const ContactPage = () => {
  return (
    <div className="flex flex-col justify-center items-center py-20 gap-10 bg-white">
      <h1 className="text-4xl  italic font-bold text-[#F4C0C0]">Contact Us</h1>
      <div className="">
        <h1 className="text-[#F4C0C0] font-bold text-lg text-center">Location</h1>
        <a className="text-gray-500 tracking-wider text-sm">Yangon, Myanmar</a>
      </div>
      <div className="">
        <h1 className="text-[#F4C0C0] font-bold text-lg text-center">Email</h1>
        <a className="text-gray-500 tracking-wider text-sm">commalaxmyanmar@gmail.com</a>
      </div>
      <div className="">
        <h1 className="text-[#F4C0C0] font-bold text-lg text-center">Phone Number</h1>
        <a className="text-gray-500 tracking-wider text-sm">09 960 322723</a>
      </div>
      <div className="">
        <h1 className="text-[#F4C0C0] font-bold text-lg text-center">Facebook</h1>
        <a
          href="https://www.facebook.com/commalaxbeauty"
          target={"_blank"}
          className="text-gray-500 tracking-wider text-sm"
        >
          https://www.facebook.com/commalaxbeauty
        </a>
      </div>
      <div className="">
        <h1 className="text-[#F4C0C0] font-bold text-lg text-center">Instagram</h1>
        <a
          href="https://www.facebook.com/commalaxbeauty"
          target={"_blank"}
          className="text-gray-500 tracking-wider text-sm"
        >
          https://www.facebook.com/commalaxbeauty
        </a>
      </div>
    </div>
  );
};

export default ContactPage;
